//=====================================================================
// Find if a navigation menu path matches the window URL (and add active)
//=====================================================================
function setCurrentNavItemJS() {
    const currentURL = window.location.pathname.replace(/\.html$/, '');
    const areasToCheck = {
        header: '[data-menu] a[href]',
        footer: '[data-menuFooter] a[href]'
    }
    const linkMatchesUrl = Array.from(document.querySelectorAll(Object.values(areasToCheck).join(', ')))
        .filter(link => link.pathname.replace(/\.html$/, '') === currentURL);

    linkMatchesUrl.forEach(link => link.classList.add('isActive'));
}

// Self-invoke the function
setCurrentNavItemJS();

// Export the function for potential use in other files
export { setCurrentNavItemJS };